import React from 'react'
import Dialog from 'material-ui/Dialog'
import { AssignRandom, CreateTable, DeleteTable, EndCall, MoveModal, ReturnToSeminar, SendAnnouncement } from './Modals'
import Loader from 'react-loader'

const modalType = (Modal) => {
  const ModalType = (props) => (
    <Dialog
      contentStyle={{
        width: (props.purpose === 'end') ? 430 : 535
      }}
      bodyStyle={{
        padding: 0
      }}
      open={props.open}>
      {(props.purpose === 'move') ? (
        <Modal>
          <MoveModal
            tableList={props.tableList}
            groupListObj={props.groupListObj}
            handleClose={props.handleClose}
            move_uid={props.move_uid}
            move_user_id={props.move_user_id}
            move_name={props.move_name}
            move_group={props.move_group}
            move_table={props.move_table}
            move_role={props.move_role}
            move_direct={props.move_direct}
            joinVideo={props.joinVideo}
          />
        </Modal>
      ) : (props.purpose === 'end') ? (
        <EndCall
          handleClose={props.handleClose}/>
      ) : (props.purpose === 'create') ? (
        <CreateTable
          createTable={props.createTable}
          snackbarOpen={props.snackbarOpen}
          tableList={props.tableList}
          handleClose={props.handleClose}
        />
      ) : (props.purpose === 'announce') ? (
        <SendAnnouncement
          name={props.name}
          snackbarOpen={props.snackbarOpen}
          handleChat={props.handleChat}
          handleClose={props.handleClose}/>
      ) : (props.purpose === 'delete') ? (
        <DeleteTable
          handleClose={props.handleClose}
          snackbarOpen={props.snackbarOpen}
          tableList={props.tableList}
          deleteTable={props.deleteTable}
          groupListObj={props.groupListObj}
        />
      ) : (props.purpose === 'return') ? (
        <ReturnToSeminar
          redirectToSeminarMode={props.redirectToSeminarMode}
          handleClose={props.handleClose}/>
      ) : (props.purpose === 'randomAssign') ? (
        <AssignRandom
          randomHandle={props.randomHandle}
          handleClose={props.handleClose}
        />
      ) : (props.purpose === 'loading') ? (
        <Modal>
          <Loader loaded={false} lines={13} length={20} width={10} radius={30}
                  corners={1} rotate={0} direction={1} color="#000" speed={1}
                  trail={60} shadow={false} hwaccel={false} className="spinner"
                  zIndex={2e9} top="50%" left="50%" scale={1.00}
                  loadedClassName="loadedContent"/>
        </Modal>
      ) : props.purpose}
    </Dialog>
  )
  return ModalType
}

export default modalType



// WEBPACK FOOTER //
// ./src/routes/BreakOutMode/ModalHOC.js